export const catalogFilterDefinitions = [
  { key: 'all', labelEn: 'All', labelHe: 'כל המוצרים' },
  { key: 'short_sleeve', labelEn: 'Short Sleeve', labelHe: 'שרוול קצר' },
  { key: 'winter', labelEn: 'Winter', labelHe: 'חורף' },
  { key: 'headwear', labelEn: 'Headwear', labelHe: 'כובעים וכיפות' }
];

export const validCatalogSearchTags = [
  'all',
  'short_sleeve',
  'winter',
  'headwear',
  'accessories'
];

export const headwearTypeOptions = [
  { key: 'classic_baseball', labelEn: 'Baseball Cap', labelHe: 'כובע מצחיה' },
  { key: 'bucket', labelEn: 'Bucket', labelHe: 'כובע פטריה' },
  { key: 'legionary', labelEn: 'Legionary', labelHe: 'כובע לגיונר' },
  { key: 'kippot', labelEn: 'Kippot', labelHe: 'כיפות' }
];

export const validHeadwearTypeKeys = headwearTypeOptions.map((option) => option.key);

export const headwearTypeSkuMap = {
  classic_baseball: ['KR2020', 'KR2210', 'KR2211', 'OM6110', 'OM6157', 'KR2220', 'TX1573'],
  bucket: ['KR2350', 'OM6500'],
  kippot: ['KR2381', 'KR2382', 'KR2385', 'KPK'],
  legionary: ['KR2310', 'KR2353']
};

export const normalizeHeadwearSku = (value) => String(value || '').trim().toUpperCase();

export const headwearSkuTypeMap = Object.entries(headwearTypeSkuMap).reduce((acc, [typeKey, skuList]) => {
  skuList.forEach((sku) => {
    acc[normalizeHeadwearSku(sku)] = typeKey;
  });
  return acc;
}, {});

export const resolveHeadwearTypeForSku = (sku) => headwearSkuTypeMap[normalizeHeadwearSku(sku)] || '';
